module.exports = __webpack_public_path__ + "jouni-nieminen_round-bcc14db7caf936080e0fb71fe205439d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/media-images/fi/jouni-nieminen_round.png
// module id = 1173
// module chunks = 1 2